"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const provider_1 = require("../../../provider/provider");
const SummaryTableEmployeeRowView_vue_1 = __importDefault(require("./SummaryTableEmployeeRowView.vue"));
const summary_lib_1 = require("../../../js/summary_lib");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SummaryTable',
    setup(__props) {
        const viewModel = (0, vue_3.inject)(provider_1.summaryTableViewModelInjectKey);
        const rowEls = (0, vue_3.ref)(null);
        const summary = document.querySelector("#summary-table-wrapper");
        // If dynamic rendering is on, maintain a list of rows we've mounted.
        const rowsMounted = (0, vue_3.ref)(new Set());
        const scrollContainer = (0, vue_3.ref)(null);
        // Only render user rows that are in scrolled view.
        const isUsingDynamicRender = (0, vue_3.ref)(false);
        if (viewModel?.value.tryUseDynamicRendering && summary) {
            // Only use the feature if the toggle is on and required elements were selected.
            isUsingDynamicRender.value = true;
        }
        (0, vue_3.onMounted)(() => {
            if (isUsingDynamicRender.value) {
                initDynamicRender();
            }
            (0, summary_lib_1.scrollToToday)();
            scrollContainer.value = document.querySelector('#summary-table-wrapper');
        });
        (0, vue_3.provide)('scrollContainer', scrollContainer);
        function intObsCallback(entries) {
            // Only mount rows intersecting current view to avoid rendering too many rows at once.
            const rowsInCurrentView = new Map();
            for (const e of entries) {
                if (!e.isIntersecting) {
                    continue;
                }
                // Target ids are user ids.
                const existing = rowsInCurrentView.get(e.target.id);
                if (!existing) {
                    rowsInCurrentView.set(e.target.id, e);
                    continue;
                }
                // If multiple entries for a given user row, keep the most recent
                if (existing.time > e.time) {
                    continue;
                }
                rowsInCurrentView.set(e.target.id, e);
            }
            for (const [, e] of rowsInCurrentView) {
                const userId = parseInt(e.target.id);
                if (!userId) {
                    continue;
                }
                rowsMounted.value.add(userId);
            }
        }
        function initDynamicRender() {
            if (!rowEls.value) {
                // Failed to find required targets. Do not use dynamic rendering.
                isUsingDynamicRender.value = false;
                return;
            }
            // Show first page of rows on page load.
            const initialPage = Math.min(25, employees.value.length);
            for (let i = 0; i < initialPage; i++) {
                rowsMounted.value.add(employees.value[i].userId);
            }
            const options = {
                root: summary,
                // Show a row that has any amount of intersect.
                threshold: 0,
            };
            const obs = new IntersectionObserver(intObsCallback, options);
            for (const rowElRef of rowEls.value) {
                const rowEl = rowElRef.$el;
                obs.observe(rowEl);
            }
        }
        const employees = (0, vue_3.computed)(() => {
            return viewModel?.value.employeeRows || [];
        });
        const dates = (0, vue_3.computed)(() => {
            return viewModel?.value.oplusTimeDateStrings || [];
        });
        const stats = (0, vue_3.computed)(() => {
            return viewModel?.value.stats;
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "#main-table" }, [
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(employees.value, (e) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SummaryTableEmployeeRowView_vue_1.default, {
                        ref_for: true,
                        ref_key: "rowEls",
                        ref: rowEls,
                        "show-data-cells": isUsingDynamicRender.value ? rowsMounted.value.has(e.userId) : true,
                        key: e.userId,
                        employee: e,
                        dates: dates.value,
                        stats: stats.value
                    }, null, 8 /* PROPS */, ["show-data-cells", "employee", "dates", "stats"]));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
